/**
 * DetailField — a labelled value used on view/detail screens. Renders a skeleton
 * while loading and an em-dash when empty, so pages compose instead of repeating
 * the same label/value markup everywhere.
 */
import { ReactNode } from 'react';

interface DetailFieldProps {
  label: string;
  children?: ReactNode;
  loading?: boolean;
  className?: string;
}

const DetailField = ({ label, children, loading = false, className = '' }: DetailFieldProps) => (
  <div className={className}>
    <label className="mb-0.5 block text-xs font-medium text-ink-muted">{label}</label>
    {loading ? (
      <div className="h-4 w-24 animate-pulse rounded bg-gray-100 dark:bg-gray-700" />
    ) : (
      <div className="text-sm text-ink">
        {children === null || children === undefined || children === '' ? '-' : children}
      </div>
    )}
  </div>
);

export default DetailField;
